<template>
  <div id="dialogs">
    <el-dialog :visible="showMassUpdateDialog" width="70%" :before-close="handleClose">
      <template slot="title">
        <template v-if="selectedRecords.length > 0">
          <div class="el-dialog__title">Mass Update {{ selectedRecords.length }} Record{{ selectedRecords.length > 1 ? 's' : '' }}</div>
          <small v-if="!loading" style="font-style: italic; display: inline-block;">Select the toggles to update individual fields</small>
        </template>
        <template v-else>
          No Records Selected
        </template>
      </template>
      <div v-if="loading" v-loading="loading" element-loading-spinner="atom-audit-loader" style="height: 390px; margin-top: -50px;"></div>

      <el-form class="massUpdateForm" v-loading="runningMassUpdate" element-loading-spinner="atom-audit-loader" size="mini" label-position="left" label-width="120px" :model="massUpdate.drgTableMassUpdateFields" ref="massUpdate" v-if="selectedRecords.length > 0 && !loading">
        <el-row>
          <el-row>
            <el-col :span="3">
              <el-switch v-model="massUpdate.updateProject" active-color="#13ce66" inactive-color="#ff4949"> </el-switch>
            </el-col>
            <el-col :span="18">
              <el-form-item size="mini" ref="projectFormItem" label="Project" prop="projectID">
                <projectSelector v-model="massUpdate.drgTableMassUpdateFields.projectID" :project="selectedProject" @selected="selectedProject = $event" :disabled="!massUpdate.updateProject" :defaultQuery="{ projectTypeId: project.projectTypeId }"> </projectSelector>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="3">
              <el-switch v-model="massUpdate.updateClientNumber" active-color="#13ce66" inactive-color="#ff4949"> </el-switch>
            </el-col>
            <el-col :span="18">
              <el-form-item ref="clientNumberFormItem" label="Facility" prop="clientNumber">
                <hia-el-select :disabled="!massUpdate.updateClientNumber" v-model="massUpdate.drgTableMassUpdateFields.clientId" placeholder="Client Number" :filterable="true" itemkey="key" label="value" :dropdowns="dropdowns.clients.list" @input="fetchDropdowns()"> </hia-el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="3">
              <el-switch v-model="massUpdate.updateDate" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
            </el-col>
            <el-col :span="18">
              <el-form-item size="mini" ref="dateFormItem" label="Review Date" prop="date">
                <el-date-picker :disabled="!massUpdate.updateDate" size="mini" type="date" v-model="massUpdate.drgTableMassUpdateFields.date" id="date" format="MM/dd/yyyy"> </el-date-picker>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="3">
              <el-switch v-model="massUpdate.updateReviewType" active-color="#13ce66" inactive-color="#ff4949"> </el-switch>
            </el-col>
            <el-col :span="18">
              <el-form-item size="mini" ref="reviewTypeFormItem" label="Review Type">
                <el-select :disabled="!massUpdate.updateReviewType" :default-first-option="true" size="mini" v-model="massUpdate.drgTableMassUpdateFields.patientType" placeholder="Review Type" clearable filterable>
                  <el-option v-for="item in dropdowns.ipPatientTypes.list" :key="item.key" :label="item.value" :value="item.key"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="3">
              <el-switch v-model="massUpdate.updateProvider" active-color="#13ce66" inactive-color="#ff4949"> </el-switch>
            </el-col>
            <el-col :span="18">
              <el-form-item size="mini" ref="providerFormItem" label="Provider">
                <providerSelector :disabled="!massUpdate.updateProvider" v-model="massUpdate.drgTableMassUpdateFields.providerId" @selected="clientProvider = $event" :provider="clientProvider"> </providerSelector>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="3">
              <el-switch v-model="massUpdate.updateConsultantNumber" active-color="#13ce66" inactive-color="#ff4949"> </el-switch>
            </el-col>
            <el-col :span="18">
              <el-form-item size="mini" ref="consultantNumberFormItem" label="Auditor">
                <el-select :disabled="!massUpdate.updateConsultantNumber" :default-first-option="true" size="mini" v-model="massUpdate.drgTableMassUpdateFields.consultantNumber" placeholder="Auditor" clearable filterable>
                  <el-option v-for="item in dropdowns.inpatientAuditors.list" :key="item.key" :label="item.value" :value="item.key"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="3">
              <el-switch v-model="massUpdate.updateCoder" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
            </el-col>
            <el-col :span="18">
              <el-form-item size="mini" ref="coderFormItem" label="Coder">
                <el-col :span="24" style="padding-left: 0px; padding-right: 0px;">
                  <coderSelector :disabled="!massUpdate.updateCoder" v-model="massUpdate.drgTableMassUpdateFields.coderId" @selected="clientCoder = $event" :clientcoder="clientCoder"> </coderSelector>
                </el-col>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="3">
              <el-switch v-model="massUpdate.updatePayor" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
            </el-col>
            <el-col :span="18">
              <el-form-item ref="payorNumberFormItem" size="mini" label="Payor">
                <hia-el-select :disabled="!massUpdate.updatePayor" v-model="massUpdate.drgTableMassUpdateFields.payorNumber" placeholder="Payor" :clearable="true" :filterable="true" itemkey="key" label="value" :dropdowns="dropdowns.payors.list"> </hia-el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="3">
              <el-switch v-model="massUpdate.updateStatus" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
            </el-col>
            <el-col :span="18">
              <el-form-item ref="statusFormItem" size="mini" label="Review Status">
                <el-select :disabled="!massUpdate.updateStatus" :default-first-option="true" size="mini" v-model="massUpdate.drgTableMassUpdateFields.reviewStatusId" placeholder="Review Status" clearable filterable>
                  <el-option v-for="item in dropdowns.reviewStatus.list" :key="item.key" :label="item.value" :value="item.key"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row>
            <el-col :span="3">
              <el-switch v-model="massUpdate.updateRecordTags" active-color="#13ce66" inactive-color="#ff4949"> </el-switch>
            </el-col>
            <el-col :span="13">
              <el-form-item size="mini" ref="recordTagsFormItem" label="Record Tags">
                <el-select class="multiSelect" :disabled="!massUpdate.updateRecordTags" size="mini" v-model="massUpdate.drgTableMassUpdateFields.tagsSelections" filterable multiple placeholder="Tags">
                  <el-option v-for="item in dropdowns.recordTags.list" :key="item.key" :label="item.value" :value="item.key" :disabled="item.inactive"> </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="5" style="margin-left: 10px;">
              <el-row>
                <input :disabled="!massUpdate.updateRecordTags" id="overwriteTagsFalse" type="radio" name="overwrite" value="false" v-model="massUpdate.overwriteTags" />
                Append Tags
              </el-row>
              <el-row> <input :disabled="!massUpdate.updateRecordTags" id="overwriteTagsTrue" type="radio" name="overwrite" value="true" v-model="massUpdate.overwriteTags" /> Overwrite Tags </el-row>
            </el-col>
          </el-row>

          <el-row style="margin-top: 6px;">
            <el-col :span="3">
              <el-switch v-model="massUpdate.updateComments" active-color="#13ce66" inactive-color="#ff4949"> </el-switch>
            </el-col>
            <el-col :span="13">
              <el-form-item label="Comments">
                <el-input :disabled="!massUpdate.updateComments" type="textarea" :rows="3" id="comments" v-model="massUpdate.drgTableMassUpdateFields.comments"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5" style="margin-left: 10px;">
              <el-row>
                <input :disabled="!massUpdate.updateComments" id="overwriteCommentsFalse" type="radio" name="overwriteComments" value="false" v-model="massUpdate.overwriteComments" />
                Append Comments
              </el-row>
              <el-row> <input :disabled="!massUpdate.updateComments" id="overwriteCommentsTrue" type="radio" name="overwriteComments" value="true" v-model="massUpdate.overwriteComments" /> Overwrite Comments </el-row>
            </el-col>
          </el-row>

          <el-row style="margin-bottom: 8px;">
            <el-col :span="3">
              <el-switch v-model="massUpdate.updatePrebill" active-color="#13ce66" inactive-color="#ff4949"> </el-switch>
            </el-col>
            <el-col :span="18"> <input :disabled="!massUpdate.updatePrebill" id="prebill" type="checkbox" v-model="massUpdate.drgTableMassUpdateFields.prebill" /> Prebill </el-col>
          </el-row>
          <el-row style="margin-bottom: 8px;">
            <el-col :span="3">
              <el-switch v-model="massUpdate.updateNoUbAvailable" active-color="#13ce66" inactive-color="#ff4949"> </el-switch>
            </el-col>
            <el-col :span="16">
              <input :disabled="!massUpdate.updateNoUbAvailable" id="noUBAvailable" type="checkbox" v-model="massUpdate.drgTableMassUpdateFields.noUbavailable" />
              No UB Available
            </el-col>
          </el-row>
        </el-row>
        <br />
      </el-form>
      <el-button-group style="float: right;">
        <el-button class="hiaButton" plain round type="text" @click="handleClose">Cancel</el-button>
        <el-button class="hiaButton" plain round :disabled="disableConfirmButton" @click="runMassUpdate(massUpdate)">Confirm</el-button>
      </el-button-group>
      <br />
    </el-dialog>
  </div>
</template>

<script>
  import projectSelector from '@/components/controls/projectSelector'
  import { mapActions, mapMutations, mapState } from 'vuex'
  import providerSelector from '@/components/controls/providerSelector'
  import coderSelector from '@/components/controls/coderSelector'

  export default {
    name: 'InpatientReviewsMassUpdate',
    props: ['selectedRecords', 'selectedClients', 'showMassUpdateDialog'],
    data() {
      return {
        loading: true,
        runningMassUpdate: false,
        form: {
          addCoder: ''
        },
        rules: {
          addCoder: [{ required: true, message: 'Please Set Coder' }]
        },
        addCoderPopOverVisible: false,
        clientCoder: {},
        selectedProject: {},
        clientProvider: {},
        massUpdate: {
          updateClientNumber: false,
          updateDate: false,
          updateReviewLevel: false,
          updateReviewType: false,
          updateConsultantNumber: false,
          updatePrebill: false,
          updateDedicatedStaffReview: false,
          updateNoUbAvailable: false,
          updateProvider: false,
          updatePOA: false,
          updateAPRDRG: false,
          updateDocEval: false,
          updateCPT: false,
          updateIcd10: false,
          updateCoder: false,
          updateComments: false,
          updatePayor: false,
          overwriteComments: false,
          overwriteTags: false,
          updateProject: false,
          updateIncludeInExit: false,
          updateCdiReview: false,
          updateStatus: false,
          updateRecordTags: false,
          drgTableIds: [],
          drgTableMassUpdateFields: {
            clientId: null,
            providerId: null,
            date: '',
            reviewLevel: '',
            patientType: '',
            consultantNumber: '',
            prebill: false,
            dedicatedStaffReview: false,
            noUbavailable: false,
            reviewPoa: false,
            reviewApr: false,
            docEval: false,
            reviewCpt: false,
            icd10: true,
            icd9: false,
            comments: '',
            projectID: 0,
            payorNumber: '',
            includeInExit: false,
            coderId: null,
            hiaCoderId: '',
            includeCdiReview: false,
            reviewStatusId: null,
            tagsSelections: []
          }
        }
      }
    },
    methods: {
      ...mapActions('inpatientReviews/', ['RUN_IP_MASSUPDATE']),
      ...mapActions('clients/coders/', ['POST_CODER']),
      ...mapActions('dropdowns', ['GET_DROPDOWNS']),
      ...mapMutations('dropdowns/', ['PUSH_NEWCODER']),
      ...mapMutations('dropdowns/', ['SET_DROPDOWNS']),
      handleClose() {
        this.$emit('close')
      },
      async fetchDropdowns() {
        this.loading = true
        await this.GET_DROPDOWNS(['reviewLevels', 'ipPatientTypes', 'inpatientAuditors', 'payors', 'reviewStatus', 'recordTags'])
        this.loading = false
      },
      runMassUpdate(massUpdate) {
        if (this.validate(massUpdate)) {
          this.confirm(massUpdate)
        }
      },
      validate(massUpdate) {
        let valid = true
        if (massUpdate.updateClientNumber && !massUpdate.drgTableMassUpdateFields.clientId) {
          this.$refs.clientNumberFormItem.$el.className += ' is-error'
          valid = false
        }
        if (massUpdate.updateDate) {
          if (!massUpdate.drgTableMassUpdateFields.date) {
            this.$refs.dateFormItem.$el.className += ' is-error'
            valid = false
          }
        }
        if (massUpdate.updateReviewLevel && !massUpdate.drgTableMassUpdateFields.reviewLevel) {
          this.$refs.reviewLevelFormItem.$el.className += ' is-error'
          valid = false
        }
        if (massUpdate.updateReviewType && !massUpdate.drgTableMassUpdateFields.patientType) {
          this.$refs.reviewTypeFormItem.$el.className += ' is-error'
          valid = false
        }
        if (massUpdate.updateConsultantNumber && !massUpdate.drgTableMassUpdateFields.consultantNumber) {
          this.$refs.consultantNumberFormItem.$el.className += ' is-error'
          valid = false
        }
        if (massUpdate.updatePayor && !massUpdate.drgTableMassUpdateFields.payorNumber) {
          this.$refs.payorNumberFormItem.$el.className += ' is-error'
          valid = false
        }

        if (massUpdate.updateStatus && !massUpdate.drgTableMassUpdateFields.reviewStatusId) {
          this.$refs.statusFormItem.$el.className += ' is-error'
          valid = false
        }

        if (massUpdate.updateProject && !massUpdate.drgTableMassUpdateFields.projectID) {
          this.$refs.projectFormItem.$el.className += ' is-error'
          valid = false
        }

        if (massUpdate.updateCoder && !massUpdate.drgTableMassUpdateFields.coderId) {
          this.$refs.coderFormItem.$el.className += ' is-error'
          valid = false
        }

        return valid
      },
      addCoderToCoderDropDown() {
        this.$refs.form.validate(valid => {
          if (valid) {
            const payload = {
              name: this.form.addCoder.toUpperCase(),
              clientNumber: this.review.clientNumber
            }
            this.POST_CODER(payload).then(response => {
              this.PUSH_NEWCODER(response)
              this.coderComputed = response.coderId
              this.putInpatientReview('coder')
              this.addCoderPopOverVisible = false
            })
          } else {
            console.log('error submit!!')
            return false
          }
        })
      },
      async confirm(massUpdate) {
        const updatedFields = []
        if (this.massUpdate.updateClientNumber) {
          updatedFields.push('Facility')
        }
        if (this.massUpdate.updateDate) {
          updatedFields.push('Date')
        }
        if (this.massUpdate.updateReviewLevel) {
          updatedFields.push('Review Level')
        }
        if (this.massUpdate.updateReviewType) {
          updatedFields.push('Review Type')
        }
        if (this.massUpdate.updateConsultantNumber) {
          updatedFields.push('Auditor')
        }
        if (this.massUpdate.updateCoder) {
          updatedFields.push('Coder')
        }
        if (this.massUpdate.updatePrebill) {
          updatedFields.push('Prebill')
        }

        if (this.massUpdate.updateNoUbAvailable) {
          updatedFields.push('No UB Available')
        }

        if (this.massUpdate.updateComments) {
          updatedFields.push('Comments')
        }
        if (this.massUpdate.updateProject) {
          updatedFields.push('Project')
        }
        if (this.massUpdate.updatePayor) {
          updatedFields.push('Payor')
        }

        if (this.massUpdate.updateStatus) {
          updatedFields.push('Review Status')
        }

        if (this.massUpdate.updateProvider) {
          updatedFields.push('Provider')
        }

        if (this.massUpdate.updateRecordTags) {
          updatedFields.push('Record Tags')
        }

        const fields = updatedFields.join(', ').replace(/,(?!.*,)/gim, ' and')
        await this.$confirm('This will update ' + fields + ' for ' + this.selectedRecords.length + ' records. Continue?', 'Warning', {
          confirmButtonText: 'OK',
          cancelButtonText: 'Cancel',
          type: 'warning'
        })

        try {
          massUpdate.drgTableIds = this.selectedRecords.map(x => x.drgTableId)
          this.runningMassUpdate = true
          await this.RUN_IP_MASSUPDATE(massUpdate)
          this.runningMassUpdate = false
          this.$emit('massupdate')
          this.$message({
            message: 'Mass Update Successful',
            type: 'success'
          })
        } catch (err) {
          console.log(err)
          this.runningMassUpdate = false
          this.$message({
            message: 'Mass Update Error',
            type: 'error'
          })
        }
      }
    },
    created: async function() {
      await this.fetchDropdowns()
    },
    computed: {
      ...mapState('dropdowns/', ['dropdowns']),
      ...mapState('managedLists/projects/', ['project']),
      coderComputed: {
        get: function() {
          if (this.massUpdate.drgTableMassUpdateFields.hiaCoderId) {
            return this.massUpdate.drgTableMassUpdateFields.hiaCoderId
          }
          return this.massUpdate.drgTableMassUpdateFields.coderId
        },
        set: function(val) {
          if (!val) {
            this.massUpdate.drgTableMassUpdateFields.hiaCoderId = null
            this.massUpdate.drgTableMassUpdateFields.coderId = null
          }

          if (typeof val === 'string') {
            this.massUpdate.drgTableMassUpdateFields.hiaCoderId = val
            this.massUpdate.drgTableMassUpdateFields.coderId = null
          } else {
            this.massUpdate.drgTableMassUpdateFields.hiaCoderId = null
            this.massUpdate.drgTableMassUpdateFields.coderId = val
          }
        }
      },
      disableConfirmButton: function() {
        if (!this.massUpdate.updateClientNumber && !this.massUpdate.updateDate && !this.massUpdate.updateReviewLevel && !this.massUpdate.updateReviewType && !this.massUpdate.updateConsultantNumber && !this.massUpdate.updateCoder && !this.massUpdate.updatePrebill && !this.massUpdate.updateNoUbAvailable && !this.massUpdate.updateComments && !this.massUpdate.updateProject && !this.massUpdate.updatePayor && !this.massUpdate.updateStatus && !this.massUpdate.updateProvider && !this.massUpdate.updateRecordTags) {
          return true
        }
        return false
      }
    },
    components: {
      projectSelector,
      coderSelector,
      providerSelector
    }
  }
</script>
